/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { Input2, DropDown2, ToggleButton, DecimalInput } from "components";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveEnterPurchaseSavingsTextBuilder = ({
  className,
  value = "",
  onChange = () => {},
}) => {
  const isUpTo = useInput(false);
  const saveStart = useInput("");
  const saveEnd = useInput("");
  const saveType = useInput("$");
  const offType = useInput("");
  const purchaseVal = useInput("");
  const purchaseType = useInput("Unit");
  const suffix = useInput("");
  const typeData = [
    { id: "$", title: "$" },
    { id: "%", title: "%" },
  ];
  const typeData2 = [
    { id: "$", title: "$" },
    { id: "Unit", title: "Unit" },
  ];
  const typeData3 = [
    { id: "entire purchase", title: "Entire Purchase" },
    { id: "any one item", title: "Any one item" },
  ];
  const withPurchaseRegex = /(w\/purchase\/\s*)+/g; // /(w\/purchase\/\s*)+/g
  const withPurchaseUnitRegex = /(w\/purchase\/\s*\.\d*\s*)+/g; // /(w\/purchase\/\s*)+/g

  const formatSaveValue = (ss, se, st) => {
    if (!ss) return "";
    return st === "$"
      ? `$${formatDollarValue(ss)}${se ? `-$${formatDollarValue(se)}` : ""}`
      : `${ss}${st}${se ? `-${se}${st}` : ""}`;
  };

  const handleUpdateValue = (ut, ss, se, st, ot, pv, pt, suf) => {
    const withPurchaseStr = `${pv ? `w/purchase/${pt === "$" ? `${pt}${formatDollarValue(pv)}` : pv}` : ''}`
    let str = [
      `Save${ut ? " Up To" : ""}`,
      formatSaveValue(ss, se, st),
      `off${ot ? ` ${ot}` : ""}`,
      withPurchaseStr,
      suf?.trim(),
    ].filter(Boolean).join(" ");
    if (purchaseVal.value)
      str = pt === "$" ? str : str.replace(withPurchaseUnitRegex, withPurchaseStr);
    else
      str = str.replace(withPurchaseRegex, 'w/purchase/');
    onChange(str);
  };

  useEffect(() => {
    if (value.startsWith("Save")) {
      let main = value.slice(4).trimStart();
      if (purchaseVal.value)
        main = main.replace(withPurchaseRegex, 'w/purchase/');
      // else
      // main = main.replace(withPurchaseRegex, 'w/purchase/');
      // main = main.replace(withPurchaseRegex, 'w/purchase/');

      if (main.startsWith("Up To")) {
        isUpTo.setValue(true);
        main = main.slice(5).trimStart();
      } else {
        isUpTo.setValue(false);
      }
      const offIndex = main.indexOf("off");
      if (offIndex >= 0) {
        const st = main.slice(0, offIndex).trim();
        if (st.startsWith("$")) {
          saveType.setValue("$");
          const parts = st.split("-");
          saveStart.setValue(parts[0].replace("$", "").trim());
          saveEnd.setValue(parts[1] ? parts[1].replace("$", "").trim() : "");
        } else if (st.endsWith("%")) {
          saveType.setValue("%");
          const parts = st.split("-");
          saveStart.setValue(parts[0].replace("%", "").trim());
          saveEnd.setValue(parts[1] ? parts[1].replace("%", "").trim() : "");
        }
        main = main.slice(offIndex + 3).trimStart();
      }
      const purchaseIndex = main.indexOf("w/purchase/");
      if (purchaseIndex >= 0) {
        offType.setValue(main.slice(0, purchaseIndex).trim());
        main = main.slice(purchaseIndex + 11);
        const sufIndex = main.indexOf(" ");
        let vt = "";
        if (sufIndex >= 0) {
          vt = main.slice(0, sufIndex);
          // suffix.setValue(main.slice(sufIndex + 1));
        } else {
          vt = main;
          // suffix.setValue("");
        }
        if (vt.startsWith("$")) {
          purchaseType.setValue("$");
          purchaseVal.setValue(vt.slice(1).trim());
        } else {
          purchaseType.setValue("Unit");
          purchaseVal.setValue(vt.trim());
        }
      } else {
        if (main.startsWith("entire purchase")) {
          offType.setValue("entire purchase");
          main = main.slice(16);
        } else if (main.startsWith("any one item")) {
          offType.setValue("any one item");
          main = main.slice(13);
        }
        // suffix.setValue(main);
      }
      value = value.replace(withPurchaseRegex, 'w/purchase/');
    }
    return () => {};
  }, [value]);

  return (
    <div className={`${className} mt-1 py-2`}>
      <Title>Incentive Text Builder</Title>
      <Container className="mt-2">
        <div className="mt-auto mb-2">Save</div>
        <ToggleButton
          className="mt-auto mb-2 ml-2"
          label="Up To"
          style={{ width: 60 }}
          value={isUpTo.value}
          onChange={(e) => {
            isUpTo.setValue(e);
            handleUpdateValue(
              e,
              saveStart.value,
              saveEnd.value,
              saveType.value,
              offType.value,
              purchaseVal.value,
              purchaseType.value,
              suffix.value
            );
          }}
        />
        <div style={{ width: 90, marginLeft: 10 }}>
          {saveType.value === "$" ? (
            <DecimalInput
              label="Start Value"
              value={saveStart.value}
              onChange={(e) => {
                saveStart.setValue(e);
                handleUpdateValue(
                  isUpTo.value,
                  e,
                  saveEnd.value,
                  saveType.value,
                  offType.value,
                  purchaseVal.value,
                  purchaseType.value,
                  suffix.value
                );
              }}
            />
          ) : (
            <Input2
              label="Start Value"
              value={saveStart.value}
              type="float"
              onChange={(e) => {
                saveStart.setValue(e);
                handleUpdateValue(
                  isUpTo.value,
                  e,
                  saveEnd.value,
                  saveType.value,
                  offType.value,
                  purchaseVal.value,
                  purchaseType.value,
                  suffix.value
                );
              }}
            />
          )}
        </div>
        <div className="mt-auto mb-2 px-1">-</div>
        <div style={{ width: 90 }}>
          {saveType.value === "$" ? (
            <DecimalInput
              label="End Value"
              value={saveEnd.value}
              onChange={(e) => {
                saveEnd.setValue(e);
                handleUpdateValue(
                  isUpTo.value,
                  saveStart.value,
                  e,
                  saveType.value,
                  offType.value,
                  purchaseVal.value,
                  purchaseType.value,
                  suffix.value
                );
              }}
            />
          ) : (
            <Input2
              label="End Value"
              value={saveEnd.value}
              type="float"
              onChange={(e) => {
                saveEnd.setValue(e);
                handleUpdateValue(
                  isUpTo.value,
                  saveStart.value,
                  e,
                  saveType.value,
                  offType.value,
                  purchaseVal.value,
                  purchaseType.value,
                  suffix.value
                );
              }}
            />
          )}
        </div>
        <div style={{ width: 60, marginLeft: 20 }}>
          <DropDown2
            label="Type"
            data={typeData}
            width={70}
            value={saveType.value}
            onChange={(e) => {
              const nextStart = e === "$" ? formatDollarValue(saveStart.value) : saveStart.value;
              const nextEnd = e === "$" ? formatDollarValue(saveEnd.value) : saveEnd.value;
              saveType.setValue(e);
              saveStart.setValue(nextStart);
              saveEnd.setValue(nextEnd);
              handleUpdateValue(
                isUpTo.value,
                nextStart,
                nextEnd,
                e,
                offType.value,
                purchaseVal.value,
                purchaseType.value,
                suffix.value
              );
            }}
          />
        </div>
      </Container>
      <Container>
        <div className="mt-auto mb-1">off</div>
        <div style={{ width: 270, marginLeft: 10 }}>
          <DropDown2
            label=""
            data={typeData3}
            width={70}
            value={offType.value}
            onChange={(e) => {
              offType.setValue(e);
              handleUpdateValue(
                isUpTo.value,
                saveStart.value,
                saveEnd.value,
                saveType.value,
                e,
                purchaseVal.value,
                purchaseType.value,
                suffix.value
              );
            }}
          />
        </div>
      </Container>
      <Container className="mt-1">
        <div className="mt-auto mb-2">w/purchase</div>
        <div style={{ width: 60, marginLeft: 10 }}>
          {purchaseType.value === "$" ? (
            <DecimalInput
              label="Value"
              value={purchaseVal.value}
              onChange={(e) => {
                purchaseVal.setValue(e);
                handleUpdateValue(
                  isUpTo.value,
                  saveStart.value,
                  saveEnd.value,
                  saveType.value,
                  offType.value,
                  e,
                  purchaseType.value,
                  suffix.value
                );
              }}
            />
          ) : (
            <Input2
              label="Value"
              value={purchaseVal.value}
              type="float"
              onChange={(e) => {
                purchaseVal.setValue(e);
                handleUpdateValue(
                  isUpTo.value,
                  saveStart.value,
                  saveEnd.value,
                  saveType.value,
                  offType.value,
                  e,
                  purchaseType.value,
                  suffix.value
                );
              }}
            />
          )}
        </div>
        <div style={{ width: 70, marginLeft: 10 }}>
          <DropDown2
            label="Type"
            data={typeData2}
            width={70}
            value={purchaseType.value}
            onChange={(e) => {
              purchaseType.setValue(e);
              handleUpdateValue(
                isUpTo.value,
                saveStart.value,
                saveEnd.value,
                saveType.value,
                offType.value,
                purchaseVal.value,
                e,
                suffix.value
              );
            }}
          />
        </div>
        <div style={{ width: 80, marginLeft: 10 }}>
          <Input2
            label="Suffix"
            value={suffix.value}
            onChange={(e) => {
              suffix.setValue(e);
              handleUpdateValue(
                isUpTo.value,
                saveStart.value,
                saveEnd.value,
                saveType.value,
                offType.value,
                purchaseVal.value,
                purchaseType.value,
                e
              );
            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
